import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const PUBLIC_API_BASE = `${BACKEND_URL}/api`;

// Cliente HTTP para endpoints públicos (sem token admin).
export const publicApi = axios.create({
  baseURL: PUBLIC_API_BASE,
  headers: { "Content-Type": "application/json" },
});

export function submitInbox({ type, name, email, phone = "", subject = "", message = "", extra = null }) {
  return publicApi.post("/inbox/submissions", {
    type,
    name,
    email,
    phone,
    subject,
    message,
    extra,
  }).then((res) => res.data);
}

export function extractError(err, fallback = "Ocorreu um erro. Tente novamente.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object") {
    // Backend pode devolver detail como objeto (ex: service_suspended)
    if (detail.message) return detail.message;
    if (detail.msg) return detail.msg;
  }
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return err?.message || fallback;
}

// Cache global do status de serviços — refresca a cada 60s
let _statusCache = { data: null, ts: 0 };
export async function fetchServiceStatus(force = false) {
  const now = Date.now();
  if (!force && _statusCache.data && now - _statusCache.ts < 60_000) {
    return _statusCache.data;
  }
  try {
    const { data } = await publicApi.get("/service-status");
    _statusCache = { data, ts: now };
    return data;
  } catch {
    return _statusCache.data || null;
  }
}
export function clearServiceStatusCache() {
  _statusCache = { data: null, ts: 0 };
}

export default publicApi;
